import { EventRegistrationAdditionalStatus } from "./types";

export const EXCESSIVE_SCORE_THRESHOLD = 200;
export const isExcessiveScore = (score: number | null) => (score || 0) >= EXCESSIVE_SCORE_THRESHOLD;

const titleize = (word: string): string => word[0].toUpperCase() + word.slice(1);
export const patSubmissionStatusOptions = (exclude: string[] = []): { value: string; displayText: string }[] =>
  Object.values(EventRegistrationAdditionalStatus)
    .filter((x) => !exclude.includes(x))
    .map((x) => ({
      value: x,
      displayText: x
        .split("_")
        .map((y) => titleize(y))
        .join(" ")
    }))
    .sort((a, b) => a.displayText.localeCompare(b.displayText));
